import Image from 'next/image'
import Link from 'next/link'
import { Agent } from '@/types/agent'

interface AgentCardProps {
  agent: Agent
  onClick?: () => void
}

export default function AgentCard({ agent, onClick }: AgentCardProps) {
  return (
    <div 
      className="w-full bg-white rounded-[12px] p-[16px] cursor-pointer hover:bg-gray-50 transition-colors native-click"
      onClick={onClick}
    >
      <div className="flex space-x-[16px]">
        {/* Avatar */}
        <div className="relative w-[100px] h-[100px] flex-shrink-0">
          <Image
            placeholder="blur"
            blurDataURL={agent.avatar}
            src={agent.avatar + '?imageslim'}
            alt={agent.name}
            fill
            className="rounded-[4px] object-cover bg-gray-300"
          />
        </div>

        {/* Info */}
        <div className="flex-1">
          <h3 className="w-[207px] font-['Mulish'] font-black text-[14px] leading-[120%] text-[#1673FF] line-clamp-1">
            {agent.name}
          </h3>
          <p className="mt-[4px] w-[207px] font-['Mulish'] text-[12px] leading-[150%] text-[#333] line-clamp-4">
            {agent.description}
          </p>
        </div>
      </div>
    </div>
  )
} 